<template>
  <div class="multi-barcode-container w-full">
    <!-- All barcodes (both existing and new) -->
    <div class="barcodes w-full">
      <div v-for="(barcode, index) in modelValue" :key="barcode.id || index" class="barcode-item w-full">
        <div class="flex gap-1 items-center mb-2 w-full">
          <el-input
            v-model="barcode.barcode"
            :placeholder="t('placeholders.barcode')"
            maxlength="63"
            clearable
            class="flex-1"
            @keypress.enter.prevent=""
          />
          <BarcodeGenerator @onBarcode="(newBarcode) => updateBarcode(index, newBarcode)"/>
          <el-button
            type="danger"
            :icon="Delete"
            circle
            size="small"
            @click="removeBarcode(index)"
            class="!ms-1"
          />
        </div>
      </div>

      <!-- Add button at the end -->
      <div class="flex justify-center mt-2">
        <el-button
          type="primary"
          :icon="Plus"
          circle
          size="small"
          @click="addBarcode"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Icon } from '@iconify/vue'
import { Delete, Plus } from '@element-plus/icons-vue'
import BarcodeGenerator from './BarcodeGenerator.vue'
import { useI18n } from 'vue-i18n'
import { ElMessageBox } from 'element-plus'
import { onMounted } from 'vue'

const { t } = useI18n()

export interface ItemBarcode {
  id?: string
  barcode: string
  description?: string
  itemID?: string
}

interface Props {
  modelValue?: ItemBarcode[]
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: () => [],
  disabled: false
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: ItemBarcode[]): void
}>()

const addBarcode = () => {
  const barcodes = [...(props.modelValue || [])]
  barcodes.push({
    barcode: ''
  })
  emit('update:modelValue', barcodes)
}

const removeBarcode = (index: number) => {
  const barcodes = [...(props.modelValue || [])]
  barcodes.splice(index, 1)
  emit('update:modelValue', barcodes)
}

const updateBarcode = (index: number, newBarcode: string) => {
  const barcodes = [...(props.modelValue || [])]
  if (barcodes[index]) {
    barcodes[index].barcode = newBarcode
    emit('update:modelValue', barcodes)
  }
}
</script>

<style scoped>
.multi-barcode-container {
  width: 100%;
}

.barcode-item {
  position: relative;
}

.add-barcode-button {
  display: flex;
  align-items: center;
}
</style>
